import { TinyColor } from '@ctrl/tinycolor';
import { css, type Theme } from '@emotion/react';

import { removeButtonAppearance } from '../../../utils/style';
import { TILE_VARIANTS } from './constants';

export const container = (theme: Theme) => css`
  ${removeButtonAppearance};

  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;
  border-radius: 8px;
  padding: 10px;

  &.${TILE_VARIANTS.NEUTRAL} {
    background-color: ${theme.colors.gray[0]};
  }

  &.${TILE_VARIANTS.PRIMARY} {
    background-color: ${theme.colors.primary[25]};
  }

  &.${TILE_VARIANTS.SECONDARY} {
    background-color: ${theme.colors.secondary[25]};
  }

  &.${TILE_VARIANTS.WARNING} {
    background-color: ${theme.colors.warning[25]};
  }

  &.${TILE_VARIANTS.SUCCESS} {
    background-color: ${theme.colors.success[25]};
  }

  &.${TILE_VARIANTS.TERTIARY} {
    background-color: ${theme.colors.tertiary[25]};
  }

  &.${TILE_VARIANTS.DISCORD} {
    background-color: #5865F2;
    color: ${theme.colors.gray[0]};
  }

  &.${TILE_VARIANTS.CHROME} {
    background:
      linear-gradient(
        0deg,
        ${new TinyColor(theme.colors.gray[0]).setAlpha(0.7).toRgbString()},
        ${new TinyColor(theme.colors.gray[0]).setAlpha(0).toRgbString()}
      ),
      linear-gradient(
        21.17deg,
        rgba(220, 220, 255, 0.28) 16.91%,
        rgba(255, 211, 206, 0.224) 39%,
        rgba(157, 255, 241, 0.14) 61.72%,
        rgba(229, 228, 187, 0.028) 91.04%
      );
  }

  &.isDisabled {
    background-color: ${theme.colors.gray[25]};
    color: ${theme.colors.gray[400]};
    cursor: default;
  }

  &.withShadow {
    box-shadow:
      0px 0px 5px 1px
        ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()},
      0px 1px 2px 0px
        ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()};
  }

  &:not(.withShadow) {
    border: 1px solid ${theme.colors.gray[100]};
  }

  &:not(.isClickable) {
    cursor: default;
  }

  @media (min-width: ${theme.breakpoints.medium}) {
    padding: 18px;
    gap: 20px;
  }
`;

export const iconContainer = (theme: Theme) => css`
  padding: 11px;
  border-radius: 4px;

  &.${TILE_VARIANTS.PRIMARY} {
    background-color: ${theme.colors.primary[50]};
  }

  &.${TILE_VARIANTS.NEUTRAL} {
    background-color: ${theme.colors.gray[100]};
  }

  &.${TILE_VARIANTS.SECONDARY} {
    background-color: ${theme.colors.secondary[50]};
  }

  &.${TILE_VARIANTS.WARNING} {
    background-color: ${theme.colors.warning[50]};
  }

  &.${TILE_VARIANTS.SUCCESS} {
    background-color: ${theme.colors.success[50]};
  }

  &.isDisabled {
    background-color: ${theme.colors.gray[100]};
  }

  @media (min-width: ${theme.breakpoints.medium}) {
    padding: 16px;
  }
`;

export const cardInfos = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
`;

export const textWithElementRight = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;

  width: 100%;
`;
